<template>
    <div :class="rowClass">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        props: {
            align: { type: String, default: 'top' },
        },

        computed: {
            rowClass() {
                return {
                    'form-row': true,
                    [`form-row--align-${this.align}`]: this.align,
                }
            },
        },
    }
</script>
